import { AutocompleteOptions, AutocompleteState, createAutocomplete } from '@algolia/autocomplete-core';
import { getAlgoliaResults } from '@algolia/autocomplete-preset-algolia';
import { Hit } from '@algolia/client-search';
import algoliasearch from 'algoliasearch';
import React from 'react';

import { ClearIcon } from './ClearIcon';
import { Highlight } from './Highlight';
import { SearchIcon } from './SearchIcon';
import { env } from '../../common/enviroment';
import { Link, withRouter } from 'react-router-dom';

const appId = 'JE8ZNLT7EN';
const apiKey = '39936e9a0779accb41fdcdfc8cae4b0b';
const searchClient = algoliasearch(appId, apiKey);

type AutocompleteItem = Hit<{
  objectID: string;
  search: string;
  art_copete: string;
  mar_nombre: string;
  art_color: string;
  art_tamano: string;
  artt_nombre: string;
  art_id: string;
  artt_id: string;
  mar_id: string;
  art_presentacion: string;
  arti_imagen: string;
  categoria_lvl0: string[];
  categoria_lvl1: string[];
  popularidad_en_pedidos: string;
  artt_orden: string;
  popularidad_porcentaje: string;
}>;

const AngoliaBuscador = (props: any) => {
  const [autocompleteState, setAutocompleteState] = React.useState<AutocompleteState<AutocompleteItem>>({
    collections: [],
    completion: null,
    context: {},
    isOpen: false,
    query: '',
    activeItemId: null,
    status: 'idle',
  });

  const [shouldShowPanel, setShouldShowPanel] = React.useState<boolean>(false);

  const autocomplete = React.useMemo(
    () =>
      createAutocomplete<AutocompleteItem, React.BaseSyntheticEvent, React.MouseEvent, React.KeyboardEvent>({
        onStateChange({ state }) {
          setAutocompleteState(state);
        },
        getSources() {
          return debounced([
            {
              sourceId: 'querySuggestions',
              getItems({ query }) {
                return getAlgoliaResults({
                  searchClient,
                  queries: [
                    {
                      indexName: 'planetoffice30_articulos_query_suggestions',
                      query,
                      params: {
                        hitsPerPage: 10,
                      },
                    },
                  ],
                });
              },
              templates: {
                item({ item }) {
                  return <div>{item.query}</div>;
                },
              },
            },
          ]);
        },
        ...props,
      }),
    []
  );

  const inputRef = React.useRef<HTMLInputElement>(null);
  const formRef = React.useRef<HTMLFormElement>(null);
  const panelRef = React.useRef<HTMLDivElement>(null);
  const { getEnvironmentProps } = autocomplete;

  React.useEffect(() => {
    if (!formRef.current || !panelRef.current || !inputRef.current) {
      return undefined;
    }

    const { onTouchStart, onTouchMove, onMouseDown } = getEnvironmentProps({
      formElement: formRef.current,
      inputElement: inputRef.current,
      panelElement: panelRef.current,
    });

    window.addEventListener('mousedown', onMouseDown);
    window.addEventListener('touchstart', onTouchStart);
    window.addEventListener('touchmove', onTouchMove);

    return () => {
      window.removeEventListener('mousedown', onMouseDown);
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchmove', onTouchMove);
    };
  }, [getEnvironmentProps, autocompleteState.isOpen]);

  React.useEffect(() => {
    if (autocompleteState.collections[0]) {
    }
  }, [autocompleteState]);

  React.useEffect(() => {
    if (
      autocompleteState &&
      autocompleteState.collections[0] &&
      autocompleteState.collections[0].items.length === 0
    ) {
      setShouldShowPanel(true);
    }
  }, [autocompleteState]);

  const setValueOnSearch = (str: string) => {
    autocomplete.setQuery(str);
    autocomplete.setIsOpen(false);
    setShouldShowPanel(false);
  };

  return (
    <div className="aa-Autocomplete" style={{ width: 'inherit' }} {...autocomplete.getRootProps({})}>
      <form
        ref={formRef}
        className="aa-Form"
        {...autocomplete.getFormProps({ inputElement: inputRef.current })}
      >
        <div className="aa-InputWrapperPrefix">
          <label className="aa-Label" style={{ marginBottom: 0 }} {...autocomplete.getLabelProps({})}>
            <button className="aa-SubmitButton" type="submit" title="Submit">
              <SearchIcon />
            </button>
          </label>
        </div>
        <div className="aa-InputWrapper">
          <input
            className="aa-Input"
            placeholder="Busca un articulo o un #codigo"
            ref={inputRef}
            {...autocomplete.getInputProps({ inputElement: inputRef.current })}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                if (inputRef.current) {
                  const value = inputRef.current.value;
                  setValueOnSearch(value);
                  if (value) props.history.push('/search/' + value);
                }
              }
            }}
          />
        </div>
        <div className="aa-InputWrapperSuffix">
          <button
            className="aa-ClearButton"
            title="Clear"
            onClick={() => {
              autocomplete.setQuery('');
              if (inputRef && inputRef.current) {
                inputRef.current.value = '';
              }
            }}
            type="button"
          >
            <ClearIcon />
          </button>
        </div>
      </form>

      {(autocompleteState.isOpen || (shouldShowPanel && inputRef.current.value)) && (
        // (inputRef.current &&
        //   inputRef.current.value &&
        //   autocompleteState.collections[0] &&
        //   autocompleteState.collections[0].items.length === 0)
        <div
          ref={panelRef}
          className={[
            'aa-Panel',
            'aa-Panel--desktop',
            autocompleteState.status === 'stalled' && 'aa-Panel--stalled',
          ]
            .filter(Boolean)
            .join(' ')}
          {...autocomplete.getPanelProps({})}
        >
          <div className="aa-PanelLayout aa-Panel--scrollable">
            {autocompleteState.collections.map((collection, index) => {
              const { source, items } = collection;

              return (
                <section key={`source-${index}`} className="aa-Source">
                  {items.length > 0 && (
                    <ul className="aa-List" {...autocomplete.getListProps()}>
                      {items.map((item, i) => {
                        if (!item.art_id) {
                          return (
                            <div
                              className="hover-result"
                              onClick={() => {
                                setValueOnSearch(item.search);
                                if (item.search) props.history.push('/search/' + item.search);
                              }}
                            >
                              {item.search}
                            </div>
                          );
                        } else {
                          return (
                            <div>
                              <Link
                                style={{ textDecoration: 'none' }}
                                className=""
                                to={'/articulo/' + item.art_id}
                              >
                                <li
                                  className="aa-Item highlight-result-algolia"
                                  id="autocomplete-0-autocomplete_demo-item-0"
                                  role="option"
                                  aria-selected="false"
                                  style={{ display: 'list-item' }}
                                >
                                  <div>
                                    <div className="row">
                                      <div className="col-3 pr-0">
                                        <img
                                          src={`${env.imagesBaseUrl}/${item.arti_imagen}`}
                                          alt={item.art_copete}
                                          height="100"
                                          style={{ verticalAlign: 'middle' }}
                                          className="img-adjust-for-mobile"
                                        />{' '}
                                      </div>
                                      <div className="col-9">
                                        <div className="row">
                                          <div className="col-12">
                                            <div
                                              className="aa-ItemContentTitle PrimaryAttribute"
                                              style={{ color: 'black', lineHeight: 'normal' }}
                                            >
                                              {item.art_copete}
                                              <span className="id-for-algolia">#{item.art_id}</span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-12">
                                            <div
                                              className="aa-ItemContentDescription SecondaryAttribute color-gris"
                                              style={{ lineHeight: 'normal', marginTop: 7 }}
                                            >
                                              {item.mar_nombre}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-12">
                                            <div
                                              className="aa-ItemContentDescription ThirdAttribute color-gris"
                                              style={{ lineHeight: 'normal', marginTop: 5 }}
                                            >
                                              {item.art_presentacion}
                                              <div style={{ float: 'right', display: 'inline-block' }}>
                                                <div className="aa-ItemContentDescription SecondaryAttribute color-gris">
                                                  {item.art_color ? '' : null}
                                                  {item.art_color ? item.art_color : null}
                                                  <span
                                                    style={
                                                      getColor(item.art_color) !== 'none'
                                                        ? { backgroundColor: getColor(item.art_color) }
                                                        : { border: '0px' }
                                                    }
                                                    className={
                                                      item.art_color && item.art_color
                                                        ? 'dot-for-algolia'
                                                        : 'hidden'
                                                    }
                                                  ></span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </Link>
                              {i === 0 && (
                                <Link
                                  style={{ textDecoration: 'none' }}
                                  className=""
                                  to={
                                    item.categoria_lvl1.length > 0
                                      ? `/productBrand/${item.mar_id}`
                                      : `/productType/${item.artt_id}`
                                  }
                                >
                                  <li
                                    className="aa-Item highlight-result-algolia"
                                    id="autocomplete-0-autocomplete_demo-item-0"
                                    role="option"
                                    aria-selected="false"
                                  >
                                    <div className="InterfaceDemoHit aa-ItemWrapper data-hj-suppress">
                                      <div className="aa-ItemContent">
                                        <div className="aa-ItemContentBody">
                                          <div className="aa-ItemContentTitle PrimaryAttribute">
                                            <span style={{ marginLeft: 15, textDecoration: 'none' }}>
                                              <i
                                                className="icon-corner-down-right"
                                                style={{ marginRight: 5 }}
                                              ></i>
                                              {item.categoria_lvl1.join(' > ')}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </Link>
                              )}
                            </div>
                          );
                        }
                      })}
                    </ul>
                  )}
                  {/* Agregar opción personalizada si no hay resultados */}
                  {items.length === 0 && inputRef.current.value && (
                    <ul className="aa-List">
                      <li
                        className="aa-Item custom-search-option"
                        onClick={() => {
                          if (inputRef.current && inputRef.current.value) {
                            // setShouldShowPanel(false);
                            const val = inputRef.current.value;
                            setValueOnSearch('');
                            props.history.push('/search/' + val);
                          }
                        }}
                      >
                        Buscar de todas formas "
                        {inputRef.current && inputRef.current.value ? inputRef.current.value : ''}"
                      </li>
                    </ul>
                  )}
                </section>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

function debouncePromise(fn, time) {
  let timerId = undefined;

  return function debounced(...args) {
    if (timerId) {
      clearTimeout(timerId);
    }

    return new Promise((resolve) => {
      timerId = setTimeout(() => resolve(fn(...args)), time);
    });
  };
}

const debounced = debouncePromise((items) => Promise.resolve(items), 350);

export default withRouter(AngoliaBuscador);

export const getColor = (color: string) => {
  if (color) {
    switch (color.toUpperCase()) {
      case 'AMARILLO':
        return '#ffff00';
      case 'AMARILLO FLUO':
        return '#effd5f';
      case 'AMARILLO OPACO':
        return '#d4af37';
      case 'AMARILLO PASTEL':
        return '#fdfd96';
      case 'AMARILLO-NEGRO':
        return '#25221e';
      case 'APPLE':
        return '#8db600';
      case 'AZUL':
        return '#0000ff';
      case 'AZUL FRANCIA':
        return '#318ce7';
      case 'AZUL MARINO':
        return '#000080';
      case 'AZUL METALIZADO':
        return '#2e5894';
      case 'AZUL OSCURO':
        return '#00008b';
      case 'AZUL PASTEL':
        return '#aec6cf';
      case 'AZUL-NEGRO':
        return '#000000';
      case 'BANANA':
        return '#e3a857';
      case 'BLANCO':
        return '#ffffff';
      case 'BLANCO-AZUL':
        return '#aec6cf';
      case 'BLANCO-NEGRO':
        return '#000000';
      case 'BLANCO-ROJO':
        return '#ffffff';
      case 'BLUEBERRY':
        return '#4f86f7';
      case 'BORDEAUX':
        return '#800020';
      case 'BORRAVINO':
        return '#800020';
      case 'BRONZE':
        return '#cd7f32';
      case 'BUBBLEGUM':
        return '#ffc1cc';
      case 'CELESTE':
        return '#b2ffff';
      case 'CELESTE FLUO':
        return '#00ffcc';
      case 'CELESTE-BLANCO':
        return '#b2ffff';
      case 'CHOCOLATE':
        return '#d2691e';
      case 'CINAMON':
        return '#d2691e';
      case 'COLA':
        return '#592720';
      case 'COLOR':
        return '#d2691e';
      case 'CRISTAL':
        return '#ffffff';
      case 'CROMADO':
        return '#a8a8a8';
      case 'CYAN':
        return '#00ffff';
      case 'CYAN CLARO':
        return '#e0ffff';
      case 'DORADO':
        return '#ffd700';
      case 'DORADO-NEGRO':
        return '#000000';
      case 'FUCSIA':
        return '#ff00ff';
      case 'GRAPE':
        return '#6f2da8';
      case 'GRIS':
        return '#808080';
      case 'GUINDA':
        return '#800000';
      case 'LADRILLO':
        return '#b22222';
      case 'LIGHT BLUE':
        return '#add8e6';
      case 'LILA':
        return '#c8a2c8';
      case 'MAGENTA':
        return '#ff00ff';
      case 'MAGENTA CLARO':
        return '#ff00ff';
      case 'MAGENTA-CYAN':
        return '#ff00ff';
      case 'MANILA':
        return '#ffdb58';
      case 'MARRON':
        return '#800000';
      case 'MARRON OSCURO':
        return '#654321';
      case 'MINT':
        return '#3eb489';
      case 'MULTICOLOR':
        return '#000000';
      case 'NARANJA':
        return '#ff7f00';
      case 'NARANJA FLUO':
        return '#ff9933';
      case 'NARANJA PASTEL':
        return '#ffa07a';
      case 'NEGRO':
        return '#000000';
      case 'NEGRO-AMARIL':
        return '#000000';
      case 'NEGRO-AMARILLO':
        return '#000000';
      case 'NEGRO-BLANCO':
        return '#000000';
      case 'NEGRO-COLOR':
        return '#000000';
      case 'NEGRO-DORADO':
        return '#000000';
      case 'NEGRO-ROJO':
        return '#000000';
      case 'NO ELEGIBLE':
        return '#000000';
      case 'OPACO':
        return '#000000';
      case 'ORANGE':
        return '#ffa500';
      case 'ORO':
        return '#ffd700';
      case 'PINTADO':
        return '#000000';
      case 'PLATA':
        return '#c0c0c0';
      case 'PLATEADO':
        return '#c0c0c0';
      case 'PLATEADO-NEGRO':
        return '#000000';
      case 'POPCORN':
        return '#f5d97e';
      case 'ROJO':
        return '#ff0000';
      case 'ROJO FLUO':
        return '#ff0000';
      case 'ROJO METALIZADO':
        return '#a52a2a';
      case 'ROJO PASTEL':
        return '#ffb6c1';
      case 'ROJO-NEGRO':
        return '#000000';
      case 'ROSA':
        return '#ff007f';
      case 'ROSA FLUO':
        return '#ff00ff';
      case 'ROSA METALIZADO':
        return '#ff007f';
      case 'ROSA PASTEL':
        return '#ffc0cb';
      case 'STRAWBERRY':
        return '#fc5a8d';
      case 'SURTIDO':
        return '#000000';
      case 'TRANSPARENTE':
        return '#ffffff';
      case 'TRANSPARENTE-NEGRO':
        return '#000000';
      case 'TURQUESA':
        return '#40e0d0';
      case 'VERDE':
        return '#008000';
      case 'VERDE AGUA':
        return '#00ffff';
      case 'VERDE CLARO':
        return '#90ee90';
      case 'VERDE FLUO':
        return '#00ff00';
      case 'VERDE MANZANA':
        return '#7fffd4';
      case 'VERDE METALIZADO':
        return '#00a550';
      case 'VERDE NOCHE':
        return '#556b2f';
      case 'VERDE OSCURO':
        return '#006400';
      case 'VERDE PASTEL':
        return '#98fb98';
      case 'VERDE-NEGRO':
        return '#000000';
      case 'VIOLETA':
        return '#8a2be2';
      case 'VIOLETA METALIZADO':
        return '#800080';
      case 'VIOLETA PASTEL':
        return '#d8bfd8';
      default:
        return 'none';
    }
  }
  return 'none';
};
